export default "__VITE_ASSET__DgXn68ew__"